import ShopGoodsLayout from './ShopGoodsLayout';
import ShopCategory from '../components/ShopCategory';
import ShopInfo from '../components/ShopInfo';
import ShopNavBar from '../components/ShopNavBar';
import ShopBanner from '../components/ShopBanner';
import { getGoodsResult } from 'api/shop';
import useAreaCookie from 'hooks/useAreaCookie';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import jsurl from 'jsurl';
import { useNetActionPriceContext } from 'libs/contexts';
import Footer from 'comps/Footer';
import Header from 'comps/Header';
import Layout from 'comps/Layout';
type ListData = {
  total: number;
  pageNo: number;
  pageSize: number;
  totalPage: number;
  datas: Array<SpuEntity>;
};

export default function ShopHome({ shopData }) {
  const router = useRouter();
  const { areaCode, getCookieAreaCode } = useAreaCookie();
  const [spuList, setSpuList] = useState<ListData>({
    total: null,
    pageNo: null,
    totalPage: null,
    pageSize: 30,
    datas: [],
  });
  const searchParams = useRef<any>({
    sorts: [{ sortField: '', orderBy: 1 }],
    keywords: '',
  });
  const getNetPriceList = useNetActionPriceContext();

  // 检查并更新searchParams
  const updateParams = () => {
    const { query } = router;
    // 路由有参数，更新searchParams
    if (query.params) {
      searchParams.current = {
        ...jsurl.parse(query.params),
      };
      // 更新searchParams后，若keywords有值，则要解码url编码
      if (searchParams.current.keywords) {
        searchParams.current.keywords = decodeURIComponent(searchParams.current.keywords);
      }
    }
  };

  useEffect(() => {
    if (!areaCode) return;
    (async () => {
      updateParams();
      getList();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areaCode, router.query.params]);

  // 获取商品列表
  async function getList() {
    const { shopSysNo, pageSysNo, isCustomCategory } = router.query;
    const catIdArr = searchParams.current?.catId?.toString().split(',') ?? null;
    const categorySysNoList = catIdArr ? [catIdArr[catIdArr.length - 1]] : [];
    const json = {
      showAllAddressId: false,
      areaLevelCode: getCookieAreaCode(),
      pageNo: 1,
      pageSize: 30,
      shopSysNoList: [shopSysNo],
      ...searchParams.current,
      shopSkuListPageSysNo: pageSysNo,
    };
    if (isCustomCategory) {
      json.shopCustomCategorySysNoList = categorySysNoList;
      json.catId = undefined;
    } else {
      json.categorySysNoList = categorySysNoList;
    }
    const res1 = await getGoodsResult({ json });
    if (res1.code === 200) {
      setSpuList(res1.data.spuList);
    }

    getNetPriceList &&
      getNetPriceList(res1?.data?.spuList?.datas, (list) => {
        setSpuList({
          ...res1?.data?.spuList,
          datas: list,
        });
      });
  }

  return (
    <Layout
      header={<Header />}
      footer={<Footer />}
      title={`店铺首页`}
      keywords=""
      description=""
      supplierSysNo={shopData.supplierSysNo}
    >
      <div className="shop-container">
        <ShopBanner shop={shopData} />
        <ShopNavBar pageType={'index'} />
        <div className="shop-wrap">
          <div className="shop-left">
            <ShopInfo shop={shopData} />
            <ShopCategory
              twoShopCustomCategoryTreeDTOList={shopData.shopCustomCategoryTreeDTOList}
            />
          </div>
          <div className="shop-right">
            <ShopGoodsLayout spuList={spuList} />
          </div>
        </div>
      </div>

      <style jsx>
        {`
          .shop-container {
            margin-bottom: 20px;
          }
          .shop-right{
            float: right;
            width: 956px;
            height: auto;
            margin-top: 20px;
          }
          .shop-left{
            float: left;
            width: 224px;
            height: auto;
            margin-top: 20px;
          }
          .shop-wrap{
            position: relative;
            width: 1200px;
            margin: 0 auto;
          }
          .shop-wrap:after{
            clear: both;
            display: block;
            content:"";
          }
          `}
      </style>
    </Layout>
  );
}
